import React, { useRef } from 'react';
import { Download, ShoppingBag, Salad, Brain, Users } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
interface Product {
  title: string;
  description: string;
  href: string;
  image?: string;
}
const PRODUCTS: Product[] = [{
  title: 'Menú Semanal VIVO',
  description: 'La guía práctica para organizar una alimentación antiinflamatoria sin pasar todo el día en la cocina.',
  href: 'https://payhip.com/b/IApx4',
  image: 'https://cdn.magicpatterns.com/uploads/kews1FQwM9ZVmh6NXhHeEj/MENU_SEMANAL.png'
}, {
  title: 'Enciende el Eje',
  description: 'Activa el sistema de regulación, energía y conexión desde la neurobiología aplicada.',
  href: 'https://payhip.com/b/ujCyI',
  image: 'https://cdn.magicpatterns.com/uploads/2rerkLWCEX6hZYLcb3jfgK/ENCIENDE_EL_EJE.png'
}, {
  title: 'Familia Viva',
  description: 'La guía práctica de co-regulación diaria para transformar el caos en calma y fortalecer el vínculo familiar.',
  href: 'https://payhip.com/b/FqmUv',
  image: 'https://cdn.magicpatterns.com/uploads/x27AkCBF12E9CAZ8m6dpAd/Familia_viva.png'
}, {
  title: 'Checklist Vivo',
  description: 'El ambiente que habla con los genes de tu hijo. Cada decisión que tomamos en casa envía un mensaje al cuerpo de nuestros hijos.',
  href: 'https://payhip.com/b/2HGA4',
  image: 'https://cdn.magicpatterns.com/uploads/vrQRM4dCmM1YTJ48WMDFpq/Checklist_VIVO.png'
}, {
  title: 'Guía de Sexualidad Sagrada Para Padres',
  description: 'Vuelve a encontrarte contigo, con tu cuerpo y con tu pareja desde un lugar de calma, seguridad y amor.',
  href: 'https://payhip.com/b/yGB5K',
  image: 'https://cdn.magicpatterns.com/uploads/uHeSgmSSHBdfE29g9H3BU5/SEXUALIDAD_SAGRADA.png'
}, {
  title: 'Intimidad Nutricional en Casa',
  description: 'Dos días de ejemplo para transformar la alimentación en un espacio de conexión, regulación y aprendizaje.',
  href: 'https://payhip.com/b/dDjT7',
  image: 'https://cdn.magicpatterns.com/uploads/pGMw2xFcyC1QBBLQS7tkdX/Intimidad_Nutricional_en_Casa.png'
}, {
  title: 'La Calma Que Se Come',
  description: 'La guía práctica para ampliar la receptividad alimentaria sin luchas, presión ni miedo. ¿Sientes que cada comida se convierte en una batalla?',
  href: 'https://payhip.com/b/E3DOT',
  image: 'https://cdn.magicpatterns.com/uploads/pKMmGrQbruKBNkQft9pmr5/LA_CALMA_QUE_SE_COME.png'
}, {
  title: 'Oxalatos',
  description: 'La guía que toda familia debería leer para comprender el impacto de los oxalatos en el comportamiento y la regulación de sus hijos.',
  href: 'https://payhip.com/b/1dk2w',
  image: 'https://cdn.magicpatterns.com/uploads/hugKYZii2uqNoqaTwrxDF5/Oxalatos.png'
}, {
  title: 'Tu Vida Enciende la Terapia y los Alimentos',
  description: 'Este e-book te ayudará a comprender por qué la verdadera transformación también depende del estilo de vida que construyes cada día.',
  href: 'https://payhip.com/b/iVC0o',
  image: 'https://cdn.magicpatterns.com/uploads/bUp2SL7Dmc2bg5v3PRKqrF/TU_VIDA_ENCIENDE_LA_TERAPIA_Y_LOS_ALIMENTOS.png'
}];
const STEPS = [{
  number: '1',
  text: 'Selecciona tu guía'
}, {
  number: '2',
  text: 'Paga de forma segura a través de Payhip'
}, {
  number: '3',
  text: 'Descarga tu recurso al instante'
}];
const TAGS = [{
  icon: Salad,
  label: 'Nutrición'
}, {
  icon: Brain,
  label: 'Neurodesarrollo'
}, {
  icon: Users,
  label: 'Familia'
}];
export function Tienda() {
  const gridRef = useRef<HTMLDivElement>(null);
  useDocumentMeta({
    title: 'Tienda | Pancita Feliz Foundation',
    description: 'Guías y recursos educativos creados por Andreina Escalante para familias con niños neurodiversos.',
    path: '/tienda'
  });
  const scrollToGrid = () => {
    gridRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <main className="w-full" data-id="element-556" data-mp="3vr6gwvtaes1f">
      {/* Hero — split layout */}
      <section className="mp-tienda-hero" style={{
      position: 'relative',
      minHeight: '480px',
      overflow: 'hidden',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      alignItems: 'center'
    }} data-id="element-557" data-mp="3vtsrl4bh5nnv">
        {/* Left: content */}
        <div className="mp-tienda-hero-left" style={{
        position: 'relative',
        background: 'linear-gradient(135deg, #0d1f07 0%, #1a3a0a 30%, #1e4d0f 60%, #0f2d05 100%)',
        padding: '80px 48px 80px 60px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        zIndex: 2
      }} data-id="element-558" data-mp="ehruzo8olbnm">
          {/* Radial light texture */}
          <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(ellipse at 20% 50%, rgba(125,201,32,0.12) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(45,90,27,0.15) 0%, transparent 50%)',
          pointerEvents: 'none',
          zIndex: 0
        }} data-id="element-559" data-mp="1272t0xyncry2" />
          {/* Left edge accent line */}
          <div aria-hidden="true" style={{
          position: 'absolute',
          left: 0,
          top: '20%',
          bottom: '20%',
          width: '3px',
          background: 'linear-gradient(to bottom, transparent, #7DC920, transparent)',
          borderRadius: '2px',
          pointerEvents: 'none',
          zIndex: 1
        }} data-id="element-560" data-mp="35gnyeuexa6lb" />
          <p style={{
          position: 'relative',
          zIndex: 1,
          color: '#7DC920',
          fontSize: '11px',
          letterSpacing: '4px',
          fontWeight: 700,
          marginBottom: '12px'
        }} data-id="element-561" data-mp="3oaa009o60m3o">
            RECURSOS EDUCATIVOS
          </p>
          <h1 className="mp-tienda-title" style={{
          position: 'relative',
          zIndex: 1,
          fontSize: '52px',
          fontWeight: 900,
          lineHeight: 1.05,
          marginBottom: '16px',
          background: 'linear-gradient(135deg, #ffffff 0%, #d4f0a0 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-562" data-mp="17un3dzt3su6j">
            Tienda de Recursos
          </h1>
          <p style={{
          position: 'relative',
          zIndex: 1,
          fontSize: '16px',
          color: 'rgba(255,255,255,0.7)',
          maxWidth: '520px',
          marginBottom: '24px'
        }} data-id="element-563" data-mp="tum24j8xfkqj">
            Guías y recursos educativos creados por Andreina Escalante para
            familias con niños neurodiversos
          </p>
          <p style={{
          position: 'relative',
          zIndex: 1,
          fontSize: '14px',
          color: 'rgba(255,255,255,0.7)',
          fontStyle: 'italic',
          marginTop: '-16px',
          marginBottom: '24px',
          maxWidth: '520px'
        }} data-id="element-564" data-mp="7ju4y61bkn7k">
            100% de las ganancias apoya los programas de la fundación (Beca
            Semilla y Beca Crecer)
          </p>
          <div className="mp-tienda-hero-stats" style={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          gap: '32px',
          marginTop: '24px'
        }} data-id="element-565" data-mp="158ntkf1panj1">
            <div data-id="element-566" data-mp="321z2xjp233mq">
              <div style={{
              fontSize: '36px',
              fontWeight: 900,
              color: '#7DC920',
              lineHeight: 1.1
            }} data-id="element-567" data-mp="322ihcqfhz9w0">
                9
              </div>
              <div style={{
              fontSize: '12px',
              color: 'rgba(255,255,255,0.7)'
            }} data-id="element-568" data-mp="2l5tir3godk6h">
                Guías disponibles
              </div>
            </div>
            <div data-id="element-569" data-mp="1xah2d3h6h1i7">
              <div style={{
              fontSize: '36px',
              fontWeight: 900,
              color: 'white',
              lineHeight: 1.1
            }} data-id="element-570" data-mp="1xaz94u1guy4d">
                $12.99
              </div>
              <div style={{
              fontSize: '12px',
              color: 'rgba(255,255,255,0.7)'
            }} data-id="element-571" data-mp="2b9qjq6h4e1nr">
                Precio por guía
              </div>
            </div>
          </div>

          <button type="button" onClick={scrollToGrid} className="mp-tienda-hero-cta" style={{
          position: 'relative',
          zIndex: 1,
          background: 'linear-gradient(135deg, #7DC920 0%, #5fa010 100%)',
          boxShadow: '0 4px 20px rgba(125,201,32,0.35)',
          color: 'white',
          fontWeight: 700,
          padding: '16px 32px',
          borderRadius: '12px',
          marginTop: '28px',
          width: 'fit-content',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-572" data-mp="3mnkhv8fzeof7">
            Ver todos los recursos ↓
          </button>
        </div>

        {/* Right: image + floating card */}
        <div className="mp-tienda-hero-right" style={{
        position: 'relative',
        height: '100%',
        minHeight: '480px',
        overflow: 'hidden',
        background: '#0f2a06'
      }} data-id="element-573" data-mp="eb9hkzq0u4or">
          <img src="https://cdn.magicpatterns.com/uploads/iYVNegFDvB4Wg2L71w2kY2/ChatGPT_Image_Jul_27,_2026,_11_12_02_PM.png" alt="Colección de guías de Andreina Escalante" style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: 0.95
        }} data-id="element-574" data-mp="28q28ilfym7ad" />
          {/* Layer 1 — green tint */}
          <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(135deg, rgba(13,31,7,0.55) 0%, rgba(45,90,27,0.25) 50%, rgba(125,201,32,0.08) 100%)',
          zIndex: 1,
          pointerEvents: 'none'
        }} data-id="element-575" data-mp="wgv3htvxphi5" />
          {/* Layer 2 — left fade blending into the panel */}
          <div aria-hidden="true" style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '120px',
          background: 'linear-gradient(to right, rgba(13,31,7,0.9) 0%, transparent 100%)',
          zIndex: 2,
          pointerEvents: 'none'
        }} data-id="element-576" data-mp="dpkc7bmar2pq" />
          {/* Layer 4 — top fade */}
          <div aria-hidden="true" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '80px',
          background: 'linear-gradient(to bottom, rgba(13,31,7,0.4) 0%, transparent 100%)',
          zIndex: 2,
          pointerEvents: 'none'
        }} data-id="element-577" data-mp="2gdtr8d30g6uh" />
          {/* Layer 3 — watermark */}
          <div aria-hidden="true" style={{
          position: 'absolute',
          bottom: '20px',
          right: '20px',
          zIndex: 3,
          pointerEvents: 'none',
          background: 'rgba(0,0,0,0.25)',
          border: '1px solid rgba(125,201,32,0.3)',
          borderRadius: '8px',
          padding: '8px 14px',
          textAlign: 'center',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)'
        }} data-id="element-578" data-mp="2z38sa7ip4vyv">
            <div style={{
            fontSize: '13px',
            fontWeight: 700,
            color: 'rgba(255,255,255,0.6)',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          }} data-id="element-579" data-mp="usdlsvukip0c">
              Pancita Feliz
            </div>
            <div style={{
            fontSize: '10px',
            fontWeight: 400,
            color: 'rgba(125,201,32,0.7)',
            letterSpacing: '3px',
            textTransform: 'uppercase'
          }} data-id="element-580" data-mp="bvks4yhhnm5h">
              Foundation
            </div>
          </div>
          <div style={{
          position: 'absolute',
          bottom: '32px',
          left: '24px',
          right: '24px',
          zIndex: 4,
          background: 'rgba(255,255,255,0.95)',
          borderRadius: '16px',
          padding: '20px 24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
        }} data-id="element-581" data-mp="21aivoqmv1has">
            <div className="flex items-center justify-between gap-4" data-id="element-582" data-mp="2njpoynm9jjj8">
              <div data-id="element-583" data-mp="1pvfinwfg29mb">
                <p style={{
                fontSize: '14px',
                fontWeight: 700,
                color: '#1a1a1a'
              }} data-id="element-584" data-mp="1pvz0ze90b00v">
                  Descarga instantánea
                </p>
                <p style={{
                fontSize: '12px',
                color: '#666'
              }} data-id="element-585" data-mp="1zvpxflh4np3l">
                  PDF de alta calidad
                </p>
              </div>
              <Download size={18} color="#7DC920" strokeWidth={1.5} className="shrink-0" data-id="element-586" data-mp="3fa3vfyry5tkv" />
            </div>
            <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            marginTop: '12px'
          }} data-id="element-587" data-mp="38u53asgti82k">
              {TAGS.map(({
              icon: Icon,
              label
            }) => <span key={label} style={{
              background: '#e8f5e0',
              color: '#2d5a1b',
              fontSize: '12px',
              fontWeight: 600,
              padding: '5px 12px',
              borderRadius: '20px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px'
            }} data-id="element-588" data-mp="3iqq8bdsu7j6e">
                  <Icon size={13} color="#2d5a1b" data-id="element-589" data-mp="jcedcwuon1lf" />
                  {label}
                </span>)}
            </div>
          </div>
        </div>
      </section>

      {/* Products grid */}
      <section ref={gridRef} style={{
      background: '#f9fdf5',
      padding: '60px 20px'
    }} data-id="element-590" data-mp="y0y22p78nt1p">
        <div className="mp-tienda-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '28px',
        maxWidth: '1000px',
        margin: '0 auto'
      }} data-id="element-591" data-mp="12wvewljamh9q">
          {PRODUCTS.map(product => <article key={product.title} className="mp-tienda-card" style={{
          background: 'white',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
          border: '1px solid #f0f0f0'
        }} data-id="element-592" data-mp="f7alf8pik1m7">
              <div className="mp-tienda-card-img" style={{
            position: 'relative',
            height: '220px',
            overflow: 'hidden',
            borderRadius: '16px 16px 0 0'
          }} data-id="element-593" data-mp="3sh89o90xpp5e">
                {product.image ? <>
                    <img src={product.image} alt={`Portada de ${product.title}`} className="mp-tienda-card-photo" style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center top'
              }} data-id="element-594" data-mp="1u6hjl4jf3gxi" />
                    <div className="mp-tienda-card-overlay" style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 60%)'
              }} data-id="element-595" data-mp="2cw68afwoe14f" />
                  </> : <div className="flex flex-col items-center justify-center" style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(135deg, #1a3a0a, #4a8a2a)'
            }} data-id="element-596" data-mp="mfu3tekkwvno">
                    <svg aria-hidden="true" width="100%" height="100%" style={{
                position: 'absolute',
                inset: 0
              }} data-id="element-597" data-mp="115hzo09zr240">
                      <circle cx="60%" cy="40%" r="80" fill="rgba(125,201,32,0.15)" data-id="element-598" data-mp="1f1lu9uos1ch0" />
                      <circle cx="40%" cy="60%" r="60" fill="rgba(255,255,255,0.08)" data-id="element-599" data-mp="3ltwd2k4q1s8r" />
                    </svg>
                    <span style={{
                fontSize: '16px',
                fontWeight: 800,
                color: 'white',
                textAlign: 'center',
                padding: '0 20px',
                lineHeight: 1.3,
                zIndex: 1,
                position: 'relative'
              }} data-id="element-600" data-mp="1mnr0ta1b3vtg">
                      {product.title}
                    </span>
                  </div>}
                <span style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: '#2d5a1b',
              color: 'white',
              fontSize: '13px',
              fontWeight: 700,
              padding: '4px 10px',
              borderRadius: '20px',
              zIndex: 2
            }} data-id="element-601" data-mp="1hp7f9aqmkm1m">
                  $12.99
                </span>
              </div>
              <div style={{
            padding: '20px 20px 24px'
          }} data-id="element-602" data-mp="2mmsxlpgsbs88">
                <h2 style={{
              fontSize: '16px',
              fontWeight: 700,
              color: '#1a1a1a',
              marginBottom: '6px',
              lineHeight: 1.3
            }} data-id="element-603" data-mp="2rl2rzxuoqoss">
                  {product.title}
                </h2>
                <p style={{
              fontSize: '13px',
              color: '#777',
              lineHeight: 1.5,
              marginBottom: '16px'
            }} data-id="element-604" data-mp="35l41g1p0n4jv">
                  {product.description}
                </p>
                <div className="flex items-center justify-between gap-3" data-id="element-605" data-mp="6x7xawxfir34">
                  <span style={{
                fontSize: '20px',
                fontWeight: 800,
                color: '#2d5a1b'
              }} data-id="element-606" data-mp="1yhsnorj5jo8p">
                    $12.99
                  </span>
                  <a href={product.href} target="_blank" rel="noopener noreferrer" className="mp-tienda-btn" style={{
                background: '#7DC920',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: 600,
                textDecoration: 'none',
                whiteSpace: 'nowrap'
              }} data-id="element-607" data-mp="1tq13cyqlaer0">
                    Obtener Guía →
                  </a>
                </div>
              </div>
            </article>)}
        </div>
      </section>

      {/* How it works */}
      <section style={{
      background: 'white',
      padding: '48px 20px',
      textAlign: 'center'
    }} data-id="element-608" data-mp="tfhyf2j26x2h">
        <ShoppingBag size={40} color="#7DC920" className="mx-auto" style={{
        marginBottom: '16px'
      }} data-id="element-609" data-mp="138pdjf3lprfr" />
        <h2 style={{
        fontSize: '24px',
        fontWeight: 700,
        color: '#1a1a1a',
        marginBottom: '24px'
      }} data-id="element-610" data-mp="1c82e1i9qz5oc">
          ¿Cómo funciona?
        </h2>
        <div className="mp-tienda-steps" style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '48px',
        maxWidth: '600px',
        margin: '0 auto'
      }} data-id="element-611" data-mp="1m6rwpd9gwu5n">
          {STEPS.map(step => <div key={step.number} className="flex flex-col items-center" style={{
          flex: 1
        }} data-id="element-612" data-mp="3iz1umcbwalr3">
              <span className="flex items-center justify-center" style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: '#7DC920',
            color: 'white',
            fontWeight: 700,
            marginBottom: '12px'
          }} data-id="element-613" data-mp="cjw4z8bqi8p2">
                {step.number}
              </span>
              <p style={{
            fontSize: '14px',
            color: '#555',
            lineHeight: 1.5
          }} data-id="element-614" data-mp="zgxvsyupvma3">
                {step.text}
              </p>
            </div>)}
        </div>
      </section>
    </main>;
}